import {
  SegmentHistoryFilters,
  SegmentRange,
} from 'business/quality-control/pages/segment-history/providers/filters';

export const formatFilterParams = (filters: SegmentHistoryFilters) => {
  const ringNumberStart =
    filters.segmentRange === null ||
    filters.segmentRange === SegmentRange.interval
      ? filters.ringNumberRange[0]
      : null;

  const ringNumberEnd =
    filters.segmentRange === null ||
    filters.segmentRange === SegmentRange.interval
      ? filters.ringNumberRange[1]
      : null;

  const lastScanRange =
    filters.segmentRange !== null &&
    filters.segmentRange !== SegmentRange.interval
      ? filters.segmentRange
      : filters.lastScanRange;

  const segmentDate =
    filters.segmentDate &&
    (filters.segmentDateRange?.[0] || filters.segmentDateRange?.[1])
      ? filters.segmentDate
      : null;

  return {
    serialNumber: filters.serialNumber,
    scanSite: filters.site,
    segmentType: filters.segmentType,
    status: filters.status,
    segmentDate,
    segmentDateStart:
      filters.segmentDateRange?.[0]?.startOf('day').toISOString() ?? null,
    segmentDateEnd:
      filters.segmentDateRange?.[1]?.endOf('day').toISOString() ?? null,
    ringNumberStart,
    ringNumberEnd,
    lastScanRange,
  };
};
